(() => {
  const initProduct = (root) => {
    if (!root || root.dataset.luxeReady === 'true') return;
    root.dataset.luxeReady = 'true';

    const mediaItems = [...root.querySelectorAll('[data-media-item]')];
    const thumbs = [...root.querySelectorAll('[data-media-target]')];
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const availability = root.querySelector('[data-availability]');
    const sku = root.querySelector('[data-product-sku]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addLabel = root.querySelector('[data-add-label]');
    const buyButton = root.querySelector('[data-buy-now]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const mobileAdd = root.querySelector('[data-mobile-add]');
    const giftAmount = root.querySelector('[data-gift-amount]');
    const initiallyAvailable = availability?.classList.contains('is-available');
    const inStockText = initiallyAvailable ? availability.textContent.trim() : 'Ready to ship';
    const soldOutText = initiallyAvailable ? 'Sold out' : (availability?.textContent?.trim() || 'Sold out');
    const addText = initiallyAvailable ? (addLabel?.textContent?.trim() || 'Add to bag') : 'Add to bag';

    const showMedia = (id) => {
      if (!id) return;
      mediaItems.forEach((item) => {
        const active = String(item.dataset.mediaItem) === String(id);
        item.hidden = !active;
        item.classList.toggle('is-active', active);
        if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((thumb) => {
        const active = String(thumb.dataset.mediaTarget) === String(id);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget)));

    root.querySelectorAll('[data-variant-picker]').forEach((picker) => {
      picker.addEventListener('change', () => {
        if (!picker.checked) return;
        const available = picker.dataset.available === 'true';
        if (price) price.textContent = picker.dataset.price || '';
        if (mobilePrice) mobilePrice.textContent = picker.dataset.price || '';
        if (giftAmount) giftAmount.textContent = picker.dataset.price || '';
        if (compare) {
          compare.textContent = picker.dataset.compare || '';
          compare.hidden = !picker.dataset.compare;
        }
        if (availability) {
          availability.textContent = available ? inStockText : soldOutText;
          availability.classList.toggle('is-available', available);
        }
        if (sku) sku.textContent = picker.dataset.sku || '';
        [addButton, buyButton, mobileAdd].forEach((button) => { if (button) button.disabled = !available; });
        if (addLabel) addLabel.textContent = available ? addText : soldOutText;
        if (mobileAdd) mobileAdd.textContent = available ? addText : soldOutText;
        showMedia(picker.dataset.mediaId);
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', picker.value);
          window.history.replaceState({}, '', url);
        } catch (_) {}
      });
    });

    const initialPicker = root.querySelector('[data-variant-picker]:checked');
    if (initialPicker?.dataset.mediaId) showMedia(initialPicker.dataset.mediaId);

    const quantityInput = root.querySelector('[data-quantity-input]');
    root.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!quantityInput) return;
        const next = Math.max(1, Number(quantityInput.value || 1) + Number(button.dataset.quantityChange || 0));
        quantityInput.value = next;
      });
    });

    const recipientToggle = root.querySelector('[data-recipient-toggle]');
    const recipientFields = root.querySelector('[data-recipient-fields]');
    if (recipientToggle && recipientFields) {
      const sendDate = recipientFields.querySelector('input[type="date"]');
      if (sendDate) sendDate.min = new Date().toISOString().split('T')[0];
      const syncRecipient = () => {
        recipientFields.hidden = !recipientToggle.checked;
        recipientFields.querySelectorAll('input, textarea').forEach((field) => {
          field.disabled = !recipientToggle.checked;
          if (field.type === 'email') field.required = recipientToggle.checked;
        });
      };
      recipientToggle.addEventListener('change', syncRecipient);
      syncRecipient();
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-product-luxe]').forEach(initProduct);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
